// @flow
import BaseComponent from '../base_component/base_component'
require( 'jszip' );
require( 'pdfmake' );
require( 'datatables.net' );
require( 'datatables.net-dt' );
require( 'datatables.net-buttons-dt' );
require( 'datatables.net-buttons/js/buttons.colVis.js' );
require( 'datatables.net-buttons/js/buttons.html5.js' );
require( 'datatables.net-buttons/js/buttons.flash.js' );
require( 'datatables.net-buttons/js/buttons.print.js' );


export default class Scorecard extends BaseComponent {
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
        this.load();
        $('#segment_select').on('change', (e) => {
         this.changeScorecard(e)
        });
    }

    load(){
        let self = this;
        $(self.component).find('#score-card-table').DataTable({
            "ordering": false,
            "searching": false,
            "autoWidth": true,
            "fixedHeader": true,
            "paging": false,
            "info": false,
            "dom": 'Bft',
            "buttons": {
                buttons: [
                    {extend: 'csv', className: 'btn btn-primary'},
                    {extend: 'excel', className: 'btn btn-primary'},
                    // {extend: 'pdf', className: 'btn btn-primary'},
                    {extend: 'print', className: 'btn btn-primary'}]
            }
        });

        $(self.component).find('#vote-breakdown-table').DataTable({
            "ordering": true,
            "searching": true,
            "autoWidth": true,
            "fixedHeader": true,
            "paging": true,
            "info": false,
            "dom": 'Bft',
            "buttons": {
                buttons: [
                    {extend: 'csv', className: 'btn btn-primary'},
                    {extend: 'excel', className: 'btn btn-primary'},
                    // {extend: 'pdf', className: 'btn btn-primary'},
                    {extend: 'print', className: 'btn btn-primary'}]
            }
        });
    }

    changeScorecard(e){
        window.location.href = '/scorecard?segment_id='+e.currentTarget.value;
    }
}